import { render, staticRenderFns } from "./ServicesSection.vue?vue&type=template&id=7939303f&scoped=true&"
import script from "./ServicesSection.vue?vue&type=script&lang=js&"
export * from "./ServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSection.vue?vue&type=style&index=0&id=7939303f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939303f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
